// extracted by mini-css-extract-plugin
export default {"fresh-instead":"jYrRbj","freshInstead":"jYrRbj","container":"CQhxWR","xs":"dwWj3f","fresh-instead-cta":"SxHwBL","freshInsteadCta":"SxHwBL","heading":"PRgmR4","copy":"MKrp4M"};